module.exports = __webpack_public_path__ + "static/media/YF45_3.f367ff22.jpg";